module.exports = __webpack_public_path__ + "static/media/br.c102d210.svg";